var E;!function(E){E.NOT_DEFINED="NOT_DEFINED",E.SQUARE="SQUARE",E.RECTANGLE="RECTANGLE",E.CUSTOM="CUSTOM"}(E||(E={}));export{E as IImageAspectRatio};
//# sourceMappingURL=LinkImageModel.js.map
